
class DeleteTherapistTypes {
 
  constructor(){
      this.searchString = undefined;
      this.searchInt = undefined;  
      this.PagingParams = {
          pageNumber : undefined,
          pageSize : undefined
      }; 
  }
}

export default DeleteTherapistTypes;

 